<template>
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item label="学习时间：">
      <el-date-picker v-model="timeRange" type="datetimerange" range-separator="至" start-placeholder="开始日期"
        end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
    </el-form-item>
    <el-form-item label="学习进度：">
      <el-select class="pro_select" v-model="filters.symbol" placeholder="学习进度">
        <el-option v-for="(item, i) in fieldData" :key="i" :label="item.paramValue" :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item >
      <div class="pro_input">
        <el-input-number v-model="filters.progress" :min="0" :max="100" :controls="false"  :precision="0">
        </el-input-number>
        <el-button class="select_btn_style">%</el-button>
      </div>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select class="select_btn_style" v-model="filters.isFinish" placeholder="完成情况">
        <el-option v-for="(item, i) in finishData" :key="i" :label="item.paramValue" :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item>
      <el-input prefix-icon="el-icon-search" v-model="filters.resourceName" placeholder="资源名称"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
// import { getRoleList } from "@/api/role";
export default {
  name: "search",
  components: {
    butn,
  },
  props: {
    initTimeRange: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    let _minTime = null;
    let _maxTime = null;
    return {
      timeRange: this.initTimeRange,
      size: "small",
      filters: {
        symbol: ">=",
      },
      sharedData: [],
      finishData: [],
      fieldData: [
        { paramValue: "大于等于", paramKey: ">=" },
        { paramValue: "等于", paramKey: "=" },
        { paramValue: "小于等于", paramKey: "<=" },
      ],
      pickerOptions: {
        disabledDate(time) {
          // onPick后触发
          // 该方法会轮询当3个月内的每一个日期，返回false表示该日期禁选
          if (_minTime && _maxTime) {
            return time.getTime() < _minTime || time.getTime() > _maxTime;
          }
        },
      },
    };
  },
  created() {
    this.getSysParamByTypes(["USER_STATUS", "PROGRESS_IS_FINISH"]);
    this.$nextTick(() => {
      this.initData();
    })
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["USER_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["PROGRESS_IS_FINISH"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.sharedData = res.data["USER_STATUS"];
        this.finishData = res.data["PROGRESS_IS_FINISH"];
      });
    },
    initData() {
      if (!this.timeRange) {
        this.$message.warning("请先选择时间范围！");
        return;
      }
      this.$emit("search", {
        ...this.filters,
        startTime: this.timeRange[0],
        endTime: this.timeRange[1],
        t: new Date().getTime(),
      });
    },
    resetData() {
      this.timeRange = this.initTimeRange;
      this.filters = {
        symbol: ">=",
      };
      this.$emit("search", {
        startTime: this.timeRange[0],
        endTime: this.timeRange[1],
        t: new Date().getTime(),
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.pro_select {
  width: 120px;
}

.pro_input {
  display: flex;
  width: 120px;
  margin-right: 10px;
  margin-left: -10px;

}
</style>
